import firebase from "firebase/app";
import "firebase/firebase-remote-config";
import Config from "../config";
import { pathOr } from "ramda";

const getFirebaseRemoteConfig = async (orgId) => {
	try {
		firebase.initializeApp(Config.firebase);
	} catch (error) {
		console.error("An error occurred while firebase initializeApp. ", error);
	}
	try{
		const remoteConfig = firebase.remoteConfig();
		remoteConfig.settings = {
			minimumFetchIntervalMillis: 60 * 1000,
		};
		await remoteConfig.fetchAndActivate();
		const response = JSON.parse(
			pathOr({}, ["_value"], remoteConfig.getValue(`organization_${orgId}`))
		);
		return pathOr(null,["allows"],response);
	}	catch (error) {
		console.error("RemoteConfig Error: ", error);
	}
};

export default {
	getFirebaseRemoteConfig
};


// WEBPACK FOOTER //
// ./src/util/firebase.js